import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { ApiSastreRecommendation, ApiSastreSizeInfo } from './sastre-button.api.model';

import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';
import { CoreStorageService } from '@core/infrastructure/storage/storage.service';
import { SastreService } from '@features/products/sastre/sastre.service';

@Injectable()
export class SastreButtonApiRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
        private readonly storageService: CoreStorageService,
    ) {}

    public sizingInfo(
        storeId: string | number,
        productId: string | number,
        locale: string,
        isVisitor: boolean,
    ): Observable<ApiSastreSizeInfo> {
        return this.http.get<ApiSastreSizeInfo>(
            this.requestService.requestUrl(
                `returns/store/${storeId}/product/${productId}/sizing-info`,
                undefined,
                [
                    { key: 'locale', value: locale },
                    { key: 'recommender', value: 'Sastre' },
                    { key: 'isVisitor', value: isVisitor.toString() },
                    isVisitor ? { key: 'visitorId', value: SastreService.getVisitorId(this.storageService) } : null,
                ].filter(p => !!p),
                true,
                '2'
            ),
            { withCredentials: true }
        );
    }

    public recommendation(
        storeId: string | number,
        productId: string | number,
        locale: string,
        isVisitor: boolean,
    ): Observable<ApiSastreRecommendation> {
        return this.http.get<ApiSastreRecommendation>(
            this.requestService.requestUrl(
                `returns/store/${storeId}/product/${productId}/recommendation`,
                undefined,
                [
                    { key: 'locale', value: locale },
                    { key: 'recommender', value: 'Sastre' },
                    { key: 'isVisitor', value: isVisitor.toString() },
                    isVisitor ? { key: 'visitorId', value: SastreService.getVisitorId(this.storageService) } : null,
                ].filter(p => !!p),
                true,
                '2'
            ),
            { withCredentials: true }
        ).pipe(
            // Puede devolver un error si no encuentra información
            catchError(() => of({
                profile: {
                    isVisitor: null,
                    name: null,
                },
                recommendation: {
                    show: null,
                    sizeResult: null,
                    returnRate: null,
                    secondarySizeResult: null,
                    secondaryReturnRate: null,
                },
            }))
        );
    }
}
